export const OSANO_CONSENT_MANAGER = 'osano_consentmanager';
